module.exports = __webpack_public_path__ + "img/logbooks.f3274b07.svg";